/* CurvaShop – galleria foto prodotto: scroll-snap + frecce, puntini, miniature, tastiera */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function smooth() { return mq && mq.matches ? 'auto' : 'smooth'; }
  function list(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (!root || root.getAttribute('data-gal-ready')) return;
    root.setAttribute('data-gal-ready', '1');
    var track = root.querySelector('[data-gal-track]');
    if (!track) return;
    var box = root.closest('.gal') || root;
    var slides = list(track, '[data-gal-slide]');
    var n = slides.length;
    if (n < 2) return;
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    var curEl = root.querySelector('[data-gal-current]');
    var status = root.querySelector('[data-gal-status]');
    var tpl = root.getAttribute('data-status') || '';
    var dots = list(box, '[data-gal-dot]');
    var thumbs = list(box, '[data-gal-thumb]');
    var thumbWrap = box.querySelector('[data-gal-thumbs]');
    var cur = -1, target = -1, raf = 0, tmr = 0;

    function mark(btns, i) {
      btns.forEach(function (b, k) {
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }
    function set(i, announce) {
      if (i === cur) return;
      cur = i;
      if (curEl) curEl.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      mark(dots, i);
      mark(thumbs, i);
      if (thumbWrap && thumbs[i] && thumbWrap.scrollWidth > thumbWrap.clientWidth) {
        var t = thumbs[i];
        thumbWrap.scrollTo({ left: t.offsetLeft - (thumbWrap.clientWidth - t.offsetWidth) / 2, behavior: smooth() });
      }
      if (announce && status) status.textContent = tpl.replace('[i]', i + 1).replace('[n]', n);
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      target = i;
      clearTimeout(tmr);
      tmr = setTimeout(function () { target = -1; }, 900);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : smooth() });
      set(i, true);
      var a = document.activeElement;
      if (a && a.disabled) track.focus({ preventScroll: true });
    }
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        var i = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
        if (target > -1) {
          if (i !== target) return;
          target = -1;
        }
        set(i, true);
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.concat(thumbs).forEach(function (b) {
      b.addEventListener('click', function () { go(+b.getAttribute('data-index')); });
    });
    box.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-gal-track],[data-gal-thumb],[data-gal-dot],[data-gal-prev],[data-gal-next]')) return;
      var k = e.key, i = null;
      if (k === 'ArrowRight') i = cur + 1;
      else if (k === 'ArrowLeft') i = cur - 1;
      else if (k === 'Home') i = 0;
      else if (k === 'End') i = n - 1;
      if (i === null) return;
      e.preventDefault();
      go(i);
      var grp = e.target.hasAttribute('data-gal-thumb') ? thumbs : e.target.hasAttribute('data-gal-dot') ? dots : null;
      if (grp && grp[cur]) grp[cur].focus({ preventScroll: true });
    });
    var rz = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () { track.scrollTo({ left: slides[cur].offsetLeft, behavior: 'auto' }); }, 120);
    });

    /* usato da theme.js al cambio variante */
    root.csGoToMedia = function (id) {
      for (var k = 0; k < n; k++) {
        if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return true; }
      }
      return false;
    };

    var start = root.getAttribute('data-start-media'), si = 0;
    if (start) slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === start) si = k; });
    set(si, false);
    if (si) requestAnimationFrame(function () { track.scrollTo({ left: slides[si].offsetLeft, behavior: 'auto' }); });
  }

  function all(scope) { list(scope || document, '[data-gallery]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();